


































































































































/** @format */

import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { getSettleReport, exportSettleReport } from '@/api/financial-management/index';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { IAntColumn } from '@root/types/table';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@root/utils/common';
import { tollManMap } from '@/types/financial-management/dictionaries';
import { baseSentryList } from '@/api/parking-lot-management/index';
import * as _ from 'lodash';
@Component({
  name: 'tollmanCheckoutStatistics',
  components: {
    ParkingLotSearch
  }
})
// @ts-ignore
export default class tollmanCheckoutStatistics extends Mixins(TableMixin, TableWidthMixin) {
  private pageSize = 10;
  private totalNum = 0;
  private totalPage = 1;
  private current = 1;
  private tableLoading = false;
  private moment = moment;
  private tableData = [];
  private tollManList = _.filter(Utils.toLabelVal(tollManMap), function(o) {
    return o.value != '01';
  });
  filterParam: any = {
    startTime: '',
    endTime: '',
    parkIds: [],
    realName: '',
    type: [],
    sentryIds: []
  };
  created() {
    this.fetchTableData(true);
  }
  onSearch() {
    this.fetchTableData(true);
  }
  /**
   * 当分页组件变化
   */
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData(false);
  }
  /**
   * 获取数据
   */
  async fetchTableData(resetPage: boolean) {
    if (resetPage) this.current = 1;
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { parkIds, startTime, endTime, type, realName, sentryIds } = this.filterParam;
      const { msg, data = {} } = await getSettleReport({
        parkId: '' + parkIds,
        type: '' + type,
        realName,
        startTime,
        endTime,
        sentryIds,
        currPage: this.current,
        pageSize: this.pageSize
      });
      const {
        datas,
        totalNum,
        totalPage,
        totalAmounts,
        tradeNums,
        totalReceivables,
        outstandingAmounts,
        electronicReceivedAmounts,
        electronicChargeCounts,
        discountMoneys
      } = data;
      this.tableData = [];
      this.totalNum = Number(totalNum);
      this.totalPage = Number(totalPage);
      if (datas.length > 0) {
        datas.push({
          totalAmount: totalAmounts || 0,
          key: 'sum',
          isTotal: true,
          tradeNum: tradeNums || 0,
          electronicChargeCount: electronicChargeCounts || 0,
          electronicReceivedAmount: electronicReceivedAmounts || 0,
          discountMoney: discountMoneys || 0,
          outstandingAmount: outstandingAmounts || 0,
          totalReceivable: totalReceivables || 0
        });
        this.tableData = Object.freeze(datas);
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /**
   * @param { 点击导出 }
   */
  private async download() {
    try {
      const { parkIds, startTime, endTime, type, realName, sentryIds } = this.filterParam;
      await exportSettleReport(
        {
          parkId: '' + parkIds,
          startTime,
          endTime,
          type: '' + type,
          realName,
          sentryIds
        },
        '收费员结账统计表'
      );
    } catch (e) {
      console.log('exportOrderEnter', '导出失败');
    }
  }

  set defaultTime(val: any) {}
  get defaultTime() {
    if (this.filterParam.startTime && this.filterParam.endTime) {
      return [
        this.moment(this.filterParam.startTime, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.endTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.startTime) {
      return [this.moment(this.filterParam.endTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }

  get tableColums(): IAntColumn[] {
    return [
      {
        title: '序号',
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '合计';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        },
        width: 70,
        fixed: 'left'
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '岗亭名称',
        dataIndex: 'sentryName',
        width: 200,
        scopedSlots: { customRender: 'sentryName' }
      },
      {
        title: '操作人',
        dataIndex: 'realName',
        width: 200
      },
      {
        title: '操作来源',
        dataIndex: 'type',
        width: 200,
        scopedSlots: { customRender: 'type' }
      },

      {
        title: '开始时间',
        dataIndex: 'startTime',
        width: 200
      },
      {
        title: '结账时间',
        dataIndex: 'endTime',
        width: 200
      },
      {
        title: '现金笔数',
        dataIndex: 'tradeNum',
        width: 180,
        scopedSlots: { customRender: 'tradeNum' }
      },
      {
        title: '现金实收金额',
        dataIndex: 'totalAmount',
        customRender: (text: any) => (text == '--' ? '--' : `￥${text}`)
      },
      {
        title: '电子收费笔数',
        dataIndex: 'electronicChargeCount',
        width: 180
      },
      {
        title: '电子实收金额',
        dataIndex: 'electronicReceivedAmount',
        width: 180,
        customRender: (text: any) => (text == '--' ? '--' : `￥${text}`)
      },
      {
        title: '优惠金额',
        dataIndex: 'discountMoney',
        width: 180,
        customRender: (text: any) => (text == '--' ? '--' : `￥${text}`)
      },
      {
        title: '未收金额',
        dataIndex: 'outstandingAmount',
        width: 180,
        customRender: (text: any) => (text == '--' ? '--' : `￥${text}`)
      },
      {
        title: '总应收金额',
        dataIndex: 'totalReceivable',
        width: 180,
        customRender: (text: any) => (text == '--' ? '--' : `￥${text}`)
      }
    ];
  }
  /**
   * 设置可选择时间
   * @param current
   */
  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  /**
   * 时间变化
   * @param date
   * @param dateString
   */
  onTimeChange(date: any, dateString: string[]) {
    let [startTime, endTime] = dateString;
    this.filterParam.startTime = startTime;
    this.filterParam.endTime = endTime;
  }

  // 车场名称改变
  handleParkChange(e) {
    // console.log(e, 'cle------>>>>', this.filterParam.parkIds);
    if (e && e.length > 0) {
      this.getbaseSentryList();
    } else {
      this.sentryList = [];
    }
  }
  handleSouChange(e) {
    // console.log(e, 'ha hah hahhahahah------->>>');
    if (e && this.sentryList && this.sentryList.length < 1) {
      this.$message.warning('请先选车场名称');
    }
  }
  sentryList = [];
  // 获取岗亭名称下拉选项
  async getbaseSentryList() {
    const res = await baseSentryList({
      currPage: 1,
      pageSize: 999999,
      parkId: this.filterParam.parkIds.join(','),
      sentryName: '',
      sentryType: ''
    });
    const { data } = res;
    this.sentryList = data.datas.map(item => {
      return { label: item.name, value: item.id };
    });
    console.log(res, 'wo lai le ');
  }

  /**
   * @param {type} property - 点击清除按钮.
   */
  onClear({ defaultParkIdList }) {
    this.filterParam = {
      startTime: '',
      endTime: '',
      parkIds: defaultParkIdList,
      realName: '',
      type: [],
      sentryIds: []
    };
    this.onSearch();
  }
  //获取收费员类型
  getTypeName(type?: String) {
    // @ts-ignore
    return type ? tollManMap[type] : '--';
  }
  //去交易记录页面
  toRecord(record) {
    const { endTime, startTime, sentryId, parkId } = record;
    this.$router.push({ name: 'TRADE_RECORD_LIST', query: { endTime, startTime, sentryId, parkId } });
  }
  filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  filterOptionT(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
}
